import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { BarChart3 } from "lucide-react";
import { WealthBeeLogo } from "@/assets/WealthBeeLogo";
import { formatFullTimestamp } from "../utils/format";
import { ReportPreviewData, ReportGenerationOptions } from "../types";

interface ReportPreviewHeaderProps {
  reportData: ReportPreviewData;
  reportOptions: ReportGenerationOptions;
}

export const ReportPreviewHeader: React.FC<ReportPreviewHeaderProps> = ({
  reportData,
  reportOptions,
}) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-start justify-between">
          <div>
            <CardTitle className="flex items-center">
              <BarChart3 className="h-5 w-5 mr-2" />
              Oversight Summary Report
            </CardTitle>
            <CardDescription>
              Run date: {formatFullTimestamp()}
            </CardDescription>
          </div>
          <WealthBeeLogo className="h-10 w-10" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <p className="text-sm text-muted-foreground">Fund</p>
            <p className="font-medium">{reportData.fundName}</p>
            <p className="text-sm text-muted-foreground">{reportData.fundKey}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Reporting Period</p>
            <p className="font-medium">{reportData.reportingPeriod}</p>
            <p className="text-sm text-muted-foreground">As of {reportData.asOfDate}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}; 